export default "__VITE_ASSET__VOLpSmVO__"